export const breadcrumb = {
  title: 'Реф. программа',
  user: {
    index: 'Мои рефералы'
  },

  profit: {
    index: 'История начислений'
  },

  request: {
    index: 'Заявки на вывод'
  }
};
